import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import { Icon } from 'components';
import { AuthContext, TeamContext, TeamContextType } from 'contexts';
import type { DashboardType } from '.';

type AppTitleProps = {
  dashboardType: DashboardType;
  currentTeamName: string;
  openDropdown?: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppTitle: React.FC<AppTitleProps> = ({
  dashboardType,
  currentTeamName,
  openDropdown,
}) => {
  const { auth } = useContext(AuthContext);

  if (!auth) return null;

  let title = `${currentTeamName || 'Team'} Dashboard`;
  if (dashboardType === 'me') {
    title = `${auth.firstName}'s Dashboard`;
  }

  return (
    <div onClick={() => openDropdown?.(prev => !prev)}>
      {title}
      {openDropdown && (
        <Icon type="arrowDownThin" width={11} offset={[4, -4]} color="black" />
      )}
    </div>
  );
};

export default AppTitle;
